<script setup lang="ts">
import { usePodcast } from "~/composables/podcast";
import FeaturedEpisode from "~/components/podcast/FeaturedEpisode.vue";
import EpisodeItemList from "~/components/podcast/EpisodeItemList.vue";

const { loading, page, episodes, podcastInfo, fetchResult } = usePodcast();
const route = useRoute();

const featuredEpisode = computed(() => {
    if (page.value > 1 || route.query.searchEpisode) return null;

    return episodes.value.length > 0 ? episodes.value[0] : null;
});

await fetchResult();
</script>

<template>
    <div class="relative pb-10">
        <div v-show="loading" class="fixed z-20 h-full w-full bg-white pt-60 text-center opacity-80">
            <img src="/images/spinnersBlocksWave.svg" alt="Spinner" class="mx-auto w-20" />
            <span class="px-4 py-2">Loading...</span>
        </div>

        <div v-if="!loading && episodes">
            <FeaturedEpisode v-if="featuredEpisode" :episode="featuredEpisode" class="mb-10" />

            <!-- List episodes -->
            <div v-if="!featuredEpisode || episodes?.length > 1" class="relative container mb-10 lg:px-20">
                <h2 class="my-10 text-center text-3xl font-bold">Previous Podcasts</h2>
                <template v-for="(episode, index) in episodes" :key="episode.id">
                    <EpisodeItemList v-if="!featuredEpisode || index > 0" :episode="episode" />
                </template>

                <div class="mt-8 text-center">
                    <a :href="podcastInfo.link" target="_blank" class="text-abc-blue">View more episodes</a>
                </div>
            </div>
            <div v-else class="mt-16 py-10 text-center text-gray-400">More episodes coming soon...</div>
        </div>
    </div>
</template>

<style scoped></style>
